import React from 'react';
import styled from 'styled-components';
import { PageFullWidth } from 'Ui';
import OptinInput from './OptinInput';
import OptinSuccessMessage from './OptinSuccesMessage';
import UiStore from 'Store/UiStore';
import notchPath from 'Assets/images/newsletterNotch.svg';

const OptinContainer = styled.div<{ $isPaymentRoute?: boolean }>`
  ${({ $isPaymentRoute }) =>
    $isPaymentRoute
      ? `
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    padding: 3.2rem;
    max-width: 130.8rem;
    margin: 0rem 2rem 4rem 2rem;
    width: calc(100% - 4rem);
    border: 3px solid var(--design-base-color);

    @media screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 4rem 3.2rem;
      margin: 0rem auto 4rem auto;
    }
  `
      : `
    form {
      border: 1px solid rgba(255, 255, 255, 0.6);
      background: #fff;
      padding: 2px;
      gap: 0 !important;
      align-items: stretch;
    }

    form > div {
      border: none !important;
      border-radius: 0 !important;
      background: #f1f1f1 !important;
      flex: 1;
      min-width: 0;
      height: 100%;
    }

    form > div > div,
    form > div > div > div {
      background: transparent !important;
    }

    input {
      background: transparent !important;
      border-radius: 0 !important;
    }

    button {
      background-color: #000 !important;
      border: none !important;
      border-radius: 0 !important;
      color: #fff !important;
      padding: 0 3.2rem !important;
      letter-spacing: 0.04em;
    }

    @media screen and (max-width: 48rem) {
      form {
        flex-direction: column !important;
        gap: 0.8rem !important;
        background: transparent;
        padding: 0;
        border: none;
      }
    }
  `}
`;

const OptinInner = styled.div<{ $isPaymentRoute?: boolean }>`
  ${({ $isPaymentRoute }) =>
    $isPaymentRoute
      ? ''
      : `
    position: relative;
    width: 100%;
    margin-bottom: 4rem;
    background-color: #000;
    overflow: hidden;
    padding: 4rem 3.2rem;

    @media screen and (min-width: 768px) {
      padding: 4rem 3.2rem 4rem 24.3rem;
    }
    @media screen and (min-width: 1024px) {
      padding-left: 27.3rem;
    }
  `}
`;

const Notch = styled.img`
  display: none;
  position: absolute;
  top: 0;
  left: 24.3rem;
  width: 5rem;
  height: 1.5rem;

  @media screen and (min-width: 48rem) {
    display: block;
  }
`;

const OptinTitle = styled.h2`
  font-family: var(--font-secondary) !important;
  font-weight: 400;
  font-size: 4.4rem;
  line-height: 44px;
  letter-spacing: 0px;
  color: #fff;
  margin: 0 0 0.8rem;
  text-transform: capitalize;

  em {
    font-family: var(--font-tertiary) !important;
    font-style: normal;
  }
`;

const OptinTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  align-items: stretch;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 4rem;
  }
`;

const OptinSubTest = styled.div<{ $isPaymentRoute?: boolean }>`
  color: ${({ $isPaymentRoute }) =>
    $isPaymentRoute ? 'var(--design-text-color)' : '#fff'};
  font-weight: ${({ $isPaymentRoute }) => ($isPaymentRoute ? 700 : 400)};
  font-family: var(--font-primary);
  font-size: 1.4rem;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  a {
    text-decoration: underline;
    font-weight: inherit;
    font-family: var(--font-primary);
  }
`;

const OptinInputContainer = styled.div`
  width: 100%;
  margin-top: 1.6rem;

  @media screen and (min-width: 768px) {
    width: 60%;
    margin-top: 0;
  }
  form {
    @media screen and (max-width: 48rem) {
      flex-direction: column !important;
    }
  }

  && {
    @media screen and (max-width: 768px) {
      form {
        display: flex !important;
        flex-direction: column !important;
        height: auto !important;
        align-items: stretch !important;
      }

      form > div {
        flex: none !important;
        width: 100% !important;
        height: 4.8rem !important;
      }

      form > button {
        flex: none !important;
        width: 100% !important;
        height: 4.8rem !important;
        margin: 0 !important;
      }
    }
  }
`;

const OptinText = styled.div<{ $isPaymentRoute?: boolean }>`
  color: ${({ $isPaymentRoute }) =>
    $isPaymentRoute ? 'var(--design-text-color)' : '#fff'};
  font-weight: 400;
  font-family: var(--font-primary);
  font-size: 1.4rem;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
`;

const OptinResponsive = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media screen and (min-width: 768px) {
    width: 40%;
  }
`;

const OptinMainText = styled.div`
  width: 100%;
`;

type TransaltionsProps = {
  title: string;
  text: string;
  subText: string;
  subText2: string;
  label: string;
  isPaymentRoute?: boolean;
};
const OptinFooter = ({
  title,
  text,
  subText,
  subText2,
  label,
  isPaymentRoute,
}: TransaltionsProps) => {
  const setOptinResponse = UiStore.useStoreActions(
    (action) => action.setOptinResponse
  );
  const optinResponse = UiStore.useStoreState((state) => state.optinResponse);
  const optinEmail: any =
    optinResponse && optinResponse.member && optinResponse.member.email;

  if (!!optinResponse) {
    setTimeout(() => {
      setOptinResponse(null);
    }, 10000);
  }

  const [titleStart, ...titleRest] = title.split(' ');
  const titleStartCap =
    titleStart.charAt(0).toUpperCase() + titleStart.slice(1);

  return (
    <PageFullWidth>
      <OptinContainer id="optinNewsletters" $isPaymentRoute={isPaymentRoute}>
      <OptinInner $isPaymentRoute={isPaymentRoute}>
        {!isPaymentRoute && (
          <>
            <Notch src={notchPath} alt="" aria-hidden="true" />
            <OptinTitle>
              {titleStartCap} <em>{titleRest.join(' ')}</em>
            </OptinTitle>
          </>
        )}
        <OptinTextContainer>
        <OptinResponsive>
          <OptinMainText>
            <OptinText $isPaymentRoute={isPaymentRoute}>{text}</OptinText>
            <OptinSubTest $isPaymentRoute={isPaymentRoute}>
              {subText}{' '}
              <a
                href="https://fr.bazarchic.com/contenu/politique-de-vie-privee/  "
                target="_blank"
              >
                {subText2}
              </a>
              .
            </OptinSubTest>
          </OptinMainText>
        </OptinResponsive>
        <OptinInputContainer>
          <OptinInput
            className="form"
            isRadius={true}
            label={label}
            isLogin={true}
          />
          {!!optinResponse && <OptinSuccessMessage emailOptin={optinEmail} />}
        </OptinInputContainer>
        </OptinTextContainer>
      </OptinInner>
      </OptinContainer>
    </PageFullWidth>
  );
};

export default OptinFooter;
